import * as R from 'ramda'
import {
  useMemo,
  useState,
  useCallback,
  KeyboardEvent,
  KeyboardEventHandler,
  useEffect,
} from 'react'
import { styled } from '@mui/material'
import { Message } from '@weblite/ts-action/message'
import { AquaList as Aqua, registerAquaManager } from '@weblite/aqua'
import { v4 as uuidV4 } from 'uuid'
import { useOpenedRoomId } from '$logic/opened-room'
import { useRoomAttribute } from '$logic/room/react-hook'
import { closeRoom } from '$logic/router'
import {
  DateSeparator,
  MessageListEmpty,
  MessageListLoading,
  MessageWrapper,
} from '$comp/_app/components/chat/components/body/components/messageList/components'
import { nothing } from '$func/utils'
import {
  IDateSeparator,
  MessageOrPendingEditUpload,
  PinListItem,
  useOpenedRoomPinList,
} from './react-hooks'

export const PINNED_LIST_AQUA_MANAGER_ID = 'pinned-list-aqua-manager'
const aquaManager = registerAquaManager(PINNED_LIST_AQUA_MANAGER_ID)

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  justify-content: flex-end;
  padding: 0;

  & > ul {
    direction: rtl;
  }
`

const LoadingContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const onKeyDown: KeyboardEventHandler<HTMLElement> = e => {
  if (e.key === 'Escape') {
    e.preventDefault()
    closeRoom()
  }
}

let handleUpdateIidsExport = null as any

export function PinList({
  toggleSelection,
}: {
  toggleSelection: (selected: boolean) => (iid: number) => unknown
}) {
  const [, setShouldHideScrollButton] = useState(true)

  const [updateKey, setUpdateKey] = useState('')

  const updateIidsHandler = useCallback(() => {
    setUpdateKey(uuidV4())
  }, [])

  useEffect(() => {
    handleUpdateIidsExport = updateIidsHandler
  }, [])

  const { loading: messagesLoading, messageList } = useOpenedRoomPinList(
    updateKey, // TODO: performance issue for using key to rerender
  )

  const roomId = useOpenedRoomId()
  const roomType = useRoomAttribute('type', roomId)

  const renderer = useCallback(
    (message: PinListItem) => {
      const { type, posInBlock, showSender, ...messageRest } = message

      // if (type === 'INLINE_LOADING')
      //   return (
      //     <MessageListLoading
      //       key="INLINE_LOADING"
      //       isInline
      //       // offset={vitrineButtonOffset}
      //     />
      //   )

      if (type === 'DATE_SEPARATOR')
        return (
          <DateSeparator
            date={message.date}
            key={message.date}
            posInBlock={posInBlock}
          />
        )

      return (
        <MessageWrapper
          key={'id' in messageRest ? messageRest.id : messageRest.date}
          // @ts-ignore
          message={{ type, ...messageRest }}
          posInBlock={posInBlock}
          showSender={showSender}
          needVisibility={false}
          toggleSelection={toggleSelection}
          roomType={roomType}
          hasPermissionToSendMessages={false}
          disableIntersection
        />
      )
    },
    [roomType],
  )

  const messagesWithInlineLoading = useMemo(() => {
    return messageList.filter(Boolean)
  }, [messageList])

  const AquaList = useMemo(
    () => (
      <Aqua
        // idKey="_id"
        managerId={PINNED_LIST_AQUA_MANAGER_ID}
        list={messagesWithInlineLoading}
        renderer={renderer}
        onReachTop={nothing}
        onReachBottom={nothing}
        setShouldHideScrollButton={setShouldHideScrollButton}
        onKeyDown={(e: KeyboardEvent<HTMLElement>) => {
          if (roomId) onKeyDown(e)
        }}
        lastMessageId={
          (R.last(messagesWithInlineLoading) as Message | undefined)?.id
        } // TODO: this should be akharin payame pin shode, not akharin payame render shode
      />
    ),
    [messagesWithInlineLoading],
  )

  return (
    <Container>
      {messagesLoading ? (
        <LoadingContainer>
          <MessageListLoading />
        </LoadingContainer>
      ) : messageList?.length ? (
        <>
          {AquaList}

          {/* <Stack */}
          {/*  sx={{ position: 'absolute', bottom: '12px', right: '12px' }} */}
          {/*  gap="16px" */}
          {/*  zIndex={1} */}
          {/* > */}
          {/*  <ScrollToBottom shouldHide={shouldHideScrollButton} /> */}
          {/* </Stack> */}
        </>
      ) : (
        <MessageListEmpty />
      )}
    </Container>
  )
}

export const pinRoomApi = {
  handleUpdateIids(iids: number[]) {
    return handleUpdateIidsExport?.(iids)
  },
}
